const R = {
    ROUTE_ABOUT: '/',

    ROUTE_WELCOME: '/welcome',
    ROUTE_USER_GUIDE: '/user_guide',

    ROUTE_EVALUATION: '/evaluate',

    ROUTE_PPE_EVALUATION: '/ppe',

    ROUTE_MOC_GUIDE: '/moc',

    ROUTE_PAC: '/pac',

    ROUTE_RESOURCE_LINKS: '/resource_links',

    ROUTE_LICENSE: '/license',
    ROUTE_ACKNOWLEDGEMENTS: '/acknowledgements',
    ROUTE_REFERENCES: '/references',
    ROUTE_CONTACT: '/contact',

    ROUTE_SETTINGS: '/settings',
};

export default R;
